import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        lxe: null,
        insert: false,
        update: false,
        loading: false
    },
    getters: {
        
    },
    mutations: {
        set(state, lxe){
            state.lxe = lxe
            if (lxe)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
        }
    },
    actions: {
        async find(store){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/Oryx/APIParameters/Find")
            .then(response => {
                let lxe = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", lxe)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
            return true
        },
        save(store){
            if (store.state.lxe.lxepadrao){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Oryx/APIParameters/Insert", store.state.lxe )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Oryx/APIParameters/Update", store.state.lxe )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete("/Oryx/APIParameters/Delete")
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
    }
}